<template>
    <nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cpath d='M1 15a.963.963 0 0 1-.707-.314 1.126 1.126 0 0 1 0-1.515L5.587 7.5.293 1.829a1.126 1.126 0 0 1 0-1.515.953.953 0 0 1 1.414 0l6 6.429c.39.418.39 1.096 0 1.515l-6 6.428A.96.96 0 0 1 1 15Z' fill='currentColor'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb" class="breadcrumb-custom">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <router-link v-if="url" :to="url">
                    <slot name="pageName"></slot>
                </router-link>
                <a v-else href="#">
                    <slot name="pageName"></slot>
                </a>
            </li>
            <li class="breadcrumb-item active" aria-current="page"><slot name="pageDetail"></slot></li>
        </ol>
        <ol class="breadcrumb">
            <li class="breadcrumb-item breadcrumb-description"><slot name="pageDescription"></slot></li>
        </ol>
    </nav>
</template>

<script>
export default {
    props: ['url']
}
</script>